// シフト関連APIまとめ
// 汎用 apiRequest をラップして、URLやパラメータを整理する目的

import { apiRequest } from "../utils/api";

/**
 * 月次シフト一覧（まとめ取得）
 *
 * バックエンド:
 * GET /inventory/shift_assignments/month_view/
 *
 * @param {Object} params
 * @param {number} params.storeId - 店舗ID
 * @param {number} params.year - 年（例: 2026）
 * @param {number} params.month - 月（例: 4）
 *
 * @returns {Promise<Object>}
 * {
 *   dates: ["2026-04-01", ...],
 *   staffs: [...],
 *   locations: [...],
 *   rows: [...]
 * }
 */
export const fetchShiftMonthView = async ({ storeId, year, month }) => {
  return apiRequest(
    `inventory/shift_assignments/month_view/?store=${storeId}&year=${year}&month=${month}`,
    "GET"
  );
};


/**
 * シフト一括保存（新規 or 更新）
 *
 * バックエンド:
 * POST /inventory/shift_assignments/bulk_upsert/
 *
 * @param {Array<Object>} items
 * [
 *   {
 *     store: 1,
 *     staff: 3,
 *     target_date: "2026-04-01",
 *     location: 2,
 *     start_time: "10:00",
 *     end_time: "18:00",
 *     is_off: false,
 *     memo: ""
 *   }
 * ]
 *
 * @returns {Promise<Array>}
 */
export const bulkUpsertShiftAssignments = async (items) => {
  return apiRequest(
    "inventory/shift_assignments/bulk_upsert/",
    "POST",
    items
  );
};


/**
 * スタッフ一覧取得
 *
 * GET /inventory/shift_staffs/
 *
 * @param {Object} params
 * @param {number} params.storeId
 * @param {boolean} [params.isActive=true]
 *
 * @returns {Promise<Array>}
 */
export const fetchShiftStaffs = async ({ storeId, isActive }) => {
  let url = `inventory/shift_staffs/?store=${storeId}`;
  if (typeof isActive === "boolean") {
    url += `&is_active=${isActive}`;
  }
  return apiRequest(url, "GET");
};
/**
 * スタッフ新規登録
 */
export const createShiftStaff = async (data) => {
  return apiRequest("inventory/shift_staffs/", "POST", data);
};

/**
 * スタッフ更新
 */
export const updateShiftStaff = async (id, data) => {
  return apiRequest(`inventory/shift_staffs/${id}/`, "PATCH", data);
};

/**
 * スタッフ削除
 */
export const deleteShiftStaff = async (id) => {
  return apiRequest(`inventory/shift_staffs/${id}/`, "DELETE");
};

/**
 * 勤務場所一覧取得（1F / 2F など）
 *
 * GET /inventory/shift_locations/
 *
 * @param {Object} params
 * @param {number} params.storeId
 * @param {boolean} [params.isActive=true]
 *
 * @returns {Promise<Array>}
 */
export const fetchShiftLocations = async ({ storeId, isActive }) => {
  let url = `inventory/shift_locations/?store=${storeId}`;
  if (typeof isActive === "boolean") {
    url += `&is_active=${isActive}`;
  }
  return apiRequest(url, "GET");
};
/**
 * 勤務場所新規登録
 */
export const createShiftLocation = async (data) => {
  return apiRequest("inventory/shift_locations/", "POST", data);
};

/**
 * 勤務場所更新
 */
export const updateShiftLocation = async (id, data) => {
  return apiRequest(`inventory/shift_locations/${id}/`, "PATCH", data);
};

/**
 * 勤務場所削除
 */
export const deleteShiftLocation = async (id) => {
  return apiRequest(`inventory/shift_locations/${id}/`, "DELETE");
};

/**
 * 休日希望一覧取得（月単位）
 *
 * GET /inventory/shift_request_offs/
 *
 * @param {Object} params
 * @param {number} params.storeId
 * @param {number} params.year
 * @param {number} params.month
 *
 * @returns {Promise<Array>}
 */
export const fetchShiftRequestOffs = async ({ storeId, year, month }) => {
  return apiRequest(
    `inventory/shift_request_offs/?store=${storeId}&year=${year}&month=${month}`,
    "GET"
  );
};


/**
 * 休日希望 登録
 *
 * POST /inventory/shift_request_offs/
 *
 * @param {Object} data
 * {
 *   store: 1,
 *   staff: 3,
 *   target_date: "2026-04-10",
 *   note: "私用"
 * }
 */
export const createShiftRequestOff = async (data) => {
  return apiRequest("inventory/shift_request_offs/", "POST", data);
};


/**
 * 休日希望 削除
 *
 * DELETE /inventory/shift_request_offs/{id}/
 *
 * @param {number} id
 */
export const deleteShiftRequestOff = async (id) => {
  return apiRequest(`inventory/shift_request_offs/${id}/`, "DELETE");
};




